import { type ComponentPropsWithoutRef, memo } from 'react';

import { MiscColorWheelIcon, Plus } from '@air/next-icons';
import { cn } from '@air/utils-tailwind';

export type CustomColorPickerToggleProps = ComponentPropsWithoutRef<'button'>;

export const CustomColorPickerToggle = memo(({ className, onClick, ...restOfProps }: CustomColorPickerToggleProps) => {
  return (
    <button
      className={cn(
        'relative flex h-6 items-center gap-1 rounded-24 border border-grey-5 px-1 uppercase ring-0 transition-colors hover:bg-grey-4 data-[selected=true]:border-grey-10 data-[selected=true]:ring-1 data-[selected=true]:ring-grey-10 data-[selected=true]:hover:bg-grey-4',
        className,
      )}
      data-testid="CUSTOM_COLOR_PICKER_BUTTON"
      onClick={onClick}
      {...restOfProps}
    >
      <MiscColorWheelIcon className="size-4" />
      <Plus className="size-3" />
    </button>
  );
});

CustomColorPickerToggle.displayName = 'CustomColorPickerToggle';
